import { Link } from 'react-router-dom';
import React from 'react';
import RegisterLogos from '../RegisterLogos/RegisterLogos';
import { Icon, TrustPilotWidget } from '@betty/moonlight';
import './AdditionalRegisterInfo.css';

function AdditionalRegisterInfo() {
  return (
    <div className="additional-register-info">
      <div className="trustpilot-wrapper">
        <TrustPilotWidget
          templateId="5419b637fa0340045cd0c936"
          className="trustpilot-register"
        />
      </div>
      <div className="iGaming-logo">
        <Link to="https://igamingontario.ca/en" target="_blank">
          <Icon name="iGamingLogo" />
        </Link>
      </div>
      <div className="other-logos">
        <RegisterLogos />
      </div>
    </div>
  );
}

export default AdditionalRegisterInfo;
